import React, { useState } from "react";

const COLLAPSED_CHAR_LIMIT = 180;

const ItemDetailCopy = ({ description }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const isCollapsible = description && description.length > COLLAPSED_CHAR_LIMIT;

  return (
    <aside
      className={`item-detail-copy${
        isCollapsible ? " item-detail-copy--collapsible" : ""
      }${isExpanded ? " item-detail-copy--expanded" : ""}`}
    >
      <p>{description}</p>
      {isCollapsible && (
        <button
          type="button"
          className="item-detail-copy-toggle"
          onClick={() => setIsExpanded((expanded) => !expanded)}
          aria-expanded={isExpanded}
        >
          {isExpanded ? "See less" : "See more"}
        </button>
      )}
    </aside>
  );
};

export default ItemDetailCopy;
